export default {
	title: "Configuração Inicial",
	complete: "Concluir",
	error: "Erro ao salvar. Tente novamente.",
	requiredHint: "Campos com * são obrigatórios.",
	step1: {
		title: "Dados do Templo",
		subtitle: "Informações básicas do seu templo",
		tradition: "Tradição Religiosa",
		zipCode: "CEP",
		city: "Cidade",
		state: "Estado",
		address: "Endereço",
		whatsapp: "WhatsApp",
		cnpj: "CNPJ",
		razaoSocial: "Razão Social",
	},
	step2: {
		title: "Seus Dados",
		subtitle: "Seu perfil no templo",
		displayName: "Nome Completo",
		religiousName: "Nome Religioso",
		religiousNameHint: "Ex: Pai João de Xangô",
		userTitle: "Título/Cargo",
		userTitleHint: "Ex: Babalorixá, Mãe de Santo, Dirigente",
		phone: "Telefone",
		whatsappOptIn: "Receber avisos do ORI por WhatsApp",
		whatsappOptInHint:
			"Enviados do número oficial do ORI para o telefone acima. Você pode desligar a qualquer momento no seu perfil.",
	},
	step3: {
		title: "Personalização",
		subtitle: "Identidade visual do templo",
		optional: "Esta etapa é opcional. Você pode configurar depois.",
		logoUrl: "URL do Logo",
		primaryColor: "Cor Principal",
	},
	step4: {
		title: "Plano",
		subtitle: "Confirme seu plano",
		hint: "Revise o plano escolhido, aplique um voucher se tiver e finalize a assinatura.",
		confirmAndPay: "Confirmar e pagar",
		decideLater: "Decidir depois",
	},
};
